// Club price info button on product cards. The cards are links, so the popover cannot live
// inside them (its sign-up links would be nested links). Instead one shared popover is appended
// to the page and positioned beside whichever info button was tapped. Delegated from document
// so it keeps working when Algolia re-renders the results.
(function () {
  let popover = null;
  let activeButton = null;
  let hoverCloseTimer = null;
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  function buildPopover() {
    const el = document.createElement('div');
    el.className = 'club-price-popover';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-label', 'OZtrail Club Price');
    el.hidden = true;
    el.innerHTML = `
      <button type="button" class="club-price-popover__close" aria-label="Close">&times;</button>
      <p class="club-price-popover__title">OZtrail Club Price</p>
      <p class="club-price-popover__text">
        <span class="club-price-popover__line">The OZtrail Club is completely <strong>FREE</strong> to join!</span>
        <span class="club-price-popover__line">
          <a href="/account/register">Create an account</a> or <a href="/account/login">log in</a>
          to unlock Club pricing on selected products.
        </span>
      </p>
    `;
    el.querySelector('.club-price-popover__close').addEventListener('click', function () {
      close(true);
    });
    // Desktop: moving from the button into the popover keeps it open so the links can be clicked
    el.addEventListener('pointerenter', function () {
      window.clearTimeout(hoverCloseTimer);
    });
    el.addEventListener('pointerleave', function (event) {
      if (event.pointerType === 'mouse') scheduleHoverClose();
    });
    document.body.appendChild(el);
    return el;
  }

  function position(button) {
    const gap = 8;
    const edge = 12;
    const rect = button.getBoundingClientRect();
    // Line the popover up with the left edge of the Club tag so it sits over its own card
    const tagRect = button.parentElement.getBoundingClientRect();
    const width = popover.offsetWidth;
    const height = popover.offsetHeight;

    let left = tagRect.left;
    left = Math.max(edge, Math.min(left, window.innerWidth - width - edge));

    let top = rect.top - height - gap;
    if (top < edge) top = rect.bottom + gap;

    popover.style.left = `${left + window.scrollX}px`;
    popover.style.top = `${top + window.scrollY}px`;
  }

  function scheduleHoverClose() {
    window.clearTimeout(hoverCloseTimer);
    hoverCloseTimer = window.setTimeout(function () {
      close(false);
    }, 250);
  }

  function open(button, viaHover) {
    window.clearTimeout(hoverCloseTimer);
    if (!popover) popover = buildPopover();
    if (activeButton === button && !popover.hidden) return;
    if (activeButton) activeButton.setAttribute('aria-expanded', 'false');
    activeButton = button;
    button.setAttribute('aria-expanded', 'true');
    popover.hidden = false;
    position(button);
    if (!viaHover) popover.querySelector('.club-price-popover__close').focus({ preventScroll: true });
  }

  function close(returnFocus) {
    if (!popover || popover.hidden) return;
    popover.hidden = true;
    if (activeButton) {
      activeButton.setAttribute('aria-expanded', 'false');
      if (returnFocus) activeButton.focus({ preventScroll: true });
    }
    activeButton = null;
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('.club-price-info');
      if (button) {
        // Stop the tap reaching the card link (which would open the product)
        event.preventDefault();
        event.stopPropagation();
        // Tapping the button always opens (and keeps open) the popover; the cross, a tap
        // outside it or Esc closes it
        open(button);
        return;
      }
      if (popover && !popover.hidden && !popover.contains(event.target)) {
        close(false);
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      close(true);
      return;
    }
    const button = event.target.closest && event.target.closest('.club-price-info');
    if (button && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      event.stopPropagation();
      open(button);
    }
  });

  // Desktop: open on hover, close shortly after the pointer leaves both the button and the popover
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType !== 'mouse' || !canHover.matches) return;
    const button = event.target.closest('.club-price-info');
    if (button) open(button, true);
  });

  document.addEventListener('pointerout', function (event) {
    if (event.pointerType !== 'mouse' || !canHover.matches) return;
    const button = event.target.closest('.club-price-info');
    if (!button || button.contains(event.relatedTarget)) return;
    if (popover && popover.contains(event.relatedTarget)) return;
    scheduleHoverClose();
  });

  // The search dropdown closes on any press outside it, and the popover sits outside it. Keep presses
  // on the info button and the popover to ourselves so the dropdown stays open.
  ['mousedown', 'touchstart', 'pointerdown'].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        if (event.target.closest('.club-price-info') || (popover && popover.contains(event.target))) {
          event.stopPropagation();
        }
      },
      true
    );
  });

  // Follow the tag when the page or a scrolling container (such as the search dropdown) scrolls
  document.addEventListener(
    'scroll',
    function () {
      if (popover && !popover.hidden && activeButton) {
        if (!activeButton.isConnected) {
          close(false);
          return;
        }
        position(activeButton);
      }
    },
    true
  );

  window.addEventListener('resize', function () {
    if (popover && !popover.hidden && activeButton) position(activeButton);
  });
})();
